import { render, staticRenderFns } from "./CreateDrayageLoad.vue?vue&type=template&id=468d25f4&scoped=true"
import script from "./CreateDrayageLoad.vue?vue&type=script&lang=js"
export * from "./CreateDrayageLoad.vue?vue&type=script&lang=js"
import style0 from "./CreateDrayageLoad.vue?vue&type=style&index=0&id=468d25f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468d25f4",
  null
  
)

export default component.exports